import React from 'react';
import { FaCheck } from 'react-icons/fa';

export const Checkbox = props => {
  const {
    label,
    value,
    checked,
    onChange,
    size,
    className = '',
    type = 'checkbox',
    icon = null,
    disabled = false,
    labelClassName = '',
    controlClassName = '',
    checkedLabelOpacity = false,
    truncateLabel = true,
  } = props;

  const isChecked = checked ?? value ?? false;
  const isRadio = type === 'radio';
  const controlSize = size === 'sm' ? 15 : size === 'lg' ? 25 : 20;
  const accentColor = 'rgb(var(--secondary))';

  const handleToggle = () => {
    if (disabled || typeof onChange !== 'function') {
      return;
    }
    onChange(!isChecked);
  };

  return (
    <button
      type='button'
      disabled={disabled}
      onClick={handleToggle}
      className={`flex items-center gap-05 text-contrast text-left transition ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
    >
      <div
        className={`shrink-0 flex items-center justify-center border-2 transition ${
          isRadio ? 'rounded-full' : 'rounded'
        } ${
          isChecked
            ? ''
            : 'border-primary border-opacity-50 bg-main bg-opacity-20'
        } ${controlClassName}`}
        style={{
          width: controlSize,
          height: controlSize,
          borderColor: isChecked ? accentColor : undefined,
          backgroundColor: isChecked
            ? 'rgb(var(--secondary) / 0.18)'
            : undefined,
        }}
      >
        {isChecked ? (
          isRadio ? (
            <div
              className='rounded-full'
              style={{ width: 8, height: 8, backgroundColor: accentColor }}
            />
          ) : (
            <FaCheck
              size={size === 'sm' ? 11 : 14}
              color={accentColor}
            />
          )
        ) : null}
      </div>

      {(icon || label) && (
        <div
          className={`min-w-0 flex items-center gap-03 text-sm text-contrast text-opacity-85 ${
            checkedLabelOpacity && isChecked ? 'opacity-60' : ''
          } ${labelClassName}`}
        >
          {icon ? <span className='inline-flex shrink-0'>{icon}</span> : null}
          {label ? (
            <span
              className={
                truncateLabel
                  ? 'truncate'
                  : 'whitespace-normal break-words'
              }
            >
              {label}
            </span>
          ) : null}
        </div>
      )}
    </button>
  );
};
